<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element-component
      class="g-grey-box"
      v-bind="{Data: {icon: ['custom', 'programs'], title: $tc('messages.sharedTexts.programs.program', 0), subTitle: computedRunningProgramsTitle}}"
    >
      <mini-programs-element
        :programs="computedRunningPrograms"
        :show-only-running-programs="true"
        @programClicked="goToProgram"
      />
      <button
        type="button"
        class="g-btn g-btn--rounded"
        @click.stop="goToPrograms()"
      >
        {{ $t('messages.sharedTexts.programs.goToPrograms') }}
      </button>
    </accordion-element-component>
  </div>
</template>

<script>
import AccordionElement from '@/components/elements/AccordionElement'
import ProgramsMini from '@/components/elements/MiniProgramsElement'

export default
{
  name: 'AccordionPrograms',
  components:
  {
    'accordion-element-component': AccordionElement,
    'mini-programs-element': ProgramsMini
  }, // Available in this.$options.name
  props: {
    programs: {
      type: Array,
      default: function() {
        return[]
      }
    },
    showOnlyRunningPrograms: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedDisabled() {
      return this.programs.length ? false : true
    },
    computedRunningProgramsTitle() {
      let rtnStr = this.$t('messages.sharedTexts.programs.loadingRunning')
      const temp = this.computedRunningPrograms.length ? `<span class="blue">${this.computedRunningPrograms.length} ${this.$t('messages.sharedTexts.status.running')}</span>` : this.computedRunningPrograms.length + ' ' + this.$t('messages.sharedTexts.status.running')

      if(this.programs.length !== 0) {
        rtnStr = `${temp}&nbsp;${this.$t('messages.sharedTexts.outOf')} ${this.programs.length}`
      }

      return rtnStr
    },
    computedRunningPrograms() {
      return this.programs.filter(program => program.runningEntries.length !== 0)
    }
  },
  methods: {
    goToPrograms() {
      this.$route.path === '/programs' ? this.$emit('toggleDashboard') : this.$router.push('/programs')
    },
    goToProgram(program) {
      this.$router.push('/programs?id=' + program.ID)
    }
  }
}
</script>

<style lang="scss">
.mini-programs-element__program {
  cursor: pointer;
}
</style>
